import React, { Component, PropTypes } from 'react';
import ListSelector from 'components/ListSelector';
import { mixin, RefluxMixin } from 'Util';
import CourseStore from 'stores/Course';
import CourseActions from 'actions/Course';

export default class CourseSelector extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    ignoreExistingCourses: PropTypes.array,
  };

  listenToStores() {
    this.listenToStore(CourseStore);
  }

  componentDidMount() {
    CourseActions.findBuildable();
  }

  getSelected() {
    return this.refs.list.getSelected();
  }

  getBuildableCourses() {
    const buildable = this.state.buildable;
    if (this.props.ignoreExistingCourses) {
      return buildable.filter(course => this.props.ignoreExistingCourses.every(id => id !== course.id));
    }

    return buildable;
  }

  render() {
    return (
      <ListSelector
        ref="list"
        searchHint={this.context.getIntlMessage('course.choose')}
        {...this.props}
        items={this.getBuildableCourses()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/CourseSelector.js